


















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Guard } from "@/store/mobile/types";

const Mobile = namespace("mobile");

@Component
export default class CoverPicker extends Vue {
	@Mobile.Action requestCoverGuard: (coverGuardId: number) => Promise<void>;
	@Mobile.Getter("getGuardId") guardId: number;
	@Mobile.State("CoverCallSigns") coverGuards: Guard[];

	public selectedGuardId: number = 0;
	public showMessage: boolean = false;

	public selectCoverGuard(guardId: number) {
		this.showMessage = false;
		this.selectedGuardId = guardId;
	}


	public cancel() {
		this.showMessage = false;
		this.selectedGuardId = 0;
		this.$emit("cancel")
	}

	public async confirm() {
		if (this.selectedGuardId == null || this.selectedGuardId === 0) {
			this.showMessage = true;
			return
		}

		await this.requestCoverGuard(this.selectedGuardId);

		this.showMessage = false;
		this.selectedGuardId = 0;

		this.$emit("confirm");
	}
}
